<div>
  @switch (ssoAttempted) {
    @case (true) {
      <p>SSO Failed</p>
    }
    @default {
      @switch (isAuthoring) {
        @case (true) {
          <p>{{authoringContent}}</p>
        }
        @default {
          <p>{{publishedContent}}</p>
        }
      }
    }
  }
</div>
